// Copyright (c) 2020-2021, 2024 Visual Intelligence LP. All rights reserved.
//
import { observable, action, makeObservable } from 'mobx';

export interface StaffUserDTO {
  fullName: string;
  email: string;
  companyId: number;
  title: string;
  roles: Array<string>;
  profileStatus: string;
  lastActivityDate: string;
  id: number;
  isBlocked: boolean;
  twoFactorEnabled: boolean;
  isActive: boolean;
  profilePhoto: any;
  specialEndorsements: Array<number>;

  // Pilot

  licenseNumber?: string;
  licenseIssueDate?: string;
  licenseExpirationDate?: string;
  licensePhoto?: any;
  baselineFlightTime?: string;
  flightsNumber?: number;
  taskAlarms?: Array<number>;
}

export default class StaffUser {
  fullName: string = '';
  email: string = '';
  companyId: number = 0;
  title: string = '';
  @observable roles: Array<string> = [];
  profileStatus: string = '';
  lastActivityDate: string = '';
  id: number = 0;
  isBlocked: boolean = false;
  twoFactorEnabled: boolean = false;
  isActive: boolean = false;
  profilePhoto: any = undefined;
  specialEndorsements: Array<number> = [];
  licenseNumber: string = '';
  licenseIssueDate: string = '';
  licenseExpirationDate: string = '';
  licensePhoto: any = undefined;
  baselineFlightTime: string = '';
  flightsNumber: number = 0;
  taskAlarms: Array<number> = [];

  constructor(dto?: Partial<StaffUserDTO>) {
    if (dto !== undefined) {
      this.update(dto);
    }
    makeObservable(this);
  }

  get asJson(): StaffUserDTO {
    return {
      fullName: this.fullName,
      email: this.email,
      companyId: this.companyId,
      title: this.title,
      roles: this.roles,
      profileStatus: this.profileStatus,
      lastActivityDate: this.lastActivityDate,
      id: this.id,
      isBlocked: this.isBlocked,
      twoFactorEnabled: this.twoFactorEnabled,
      isActive: this.isActive,
      profilePhoto: this.profilePhoto,
      specialEndorsements: this.specialEndorsements,
      licenseNumber: this.licenseNumber,
      licenseIssueDate: this.licenseIssueDate,
      licenseExpirationDate: this.licenseExpirationDate,
      licensePhoto: this.licensePhoto,
      baselineFlightTime: this.baselineFlightTime,
      flightsNumber: this.flightsNumber,
      taskAlarms: this.taskAlarms,
    };
  }

  @action update(newData: Partial<StaffUserDTO>): StaffUserDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    return this.asJson;
  }
}